export function getPathValue(source: unknown, path: string): unknown {
  return path.split(".").reduce<unknown>((current, key) => {
    if (current && typeof current === "object" && key in current) return (current as Record<string, unknown>)[key];
    return undefined;
  }, source);
}

export function setPathValue<T>(source: T, path: string, value: unknown): T {
  const cloned = structuredClone(source) as Record<string, unknown>;
  const keys = path.split(".");
  let cursor: Record<string, unknown> = cloned;
  keys.slice(0, -1).forEach((key) => {
    if (!cursor[key] || typeof cursor[key] !== "object") cursor[key] = {};
    cursor = cursor[key] as Record<string, unknown>;
  });
  cursor[keys[keys.length - 1]] = value;
  return cloned as T;
}

export function fieldValueToString(value: unknown): string {
  if (typeof value === "string") return value;
  if (typeof value === "number") return String(value);
  return "";
}

function getLastHangulChar(value: string): string | null {
  const chars = Array.from(value.trim()).reverse();
  return chars.find((char) => /[가-힣]/.test(char)) ?? null;
}

function hasFinalConsonant(value: string): boolean {
  const char = getLastHangulChar(value);
  if (!char) return false;
  return (char.charCodeAt(0) - 0xac00) % 28 > 0;
}

export function withObjectParticle(value: string): string {
  return `${value}${hasFinalConsonant(value) ? "을" : "를"}`;
}

export function withSubjectParticle(value: string): string {
  return `${value}${hasFinalConsonant(value) ? "이" : "가"}`;
}
